import CoreAccountMediaPanel from 'core/js/pages/municipality-data/balance/account/_account_media_panel/index.js'
import Transaction from './_transaction.js'

// @vue/component
export default {
  extends: CoreAccountMediaPanel,
  components: {
    ...CoreAccountMediaPanel.components,
    Transaction
  }
}
